<template>
    <el-dialog
        class="detail-remark"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Detail Remark"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="detailForm"
                :model="detailForm"
                :rules="rules"
                label-width="80px"
                disabled
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Shop" prop="shop_id" size="small">
                            <el-select
                                v-model="detailForm.shop_id"
                                size="small"
                                clearable
                                filterable
                                placeholder="Placeholder Shop"
                            >
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Customer" prop="user_name" size="small">
                            <el-select
                                v-model="detailForm.user_name"
                                placeholder="Please input user"
                                filterable
                                clearable
                                :filter-method="userSelect"
                                :remote="true"
                            >
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.username"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Desc" prop="remark" size="small">
                            <el-input
                                type="textarea"
                                v-model="detailForm.remark"
                                placeholder="Please input remark"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            detailForm: {
                shop_id: "",
                user_id: "",
                user_name: "",
                remark: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                value: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "Please select time",
                    },
                ],
            },
            userList:[],
        };
    },
    methods: {
        closeDialog() {
            this.detailForm = {
                shop_id: "",
                user_id: "",
                user_name: "",
                remark: "",
            };
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        shopOrderRemark() {
            cmofferApi
                .shopOrderRemark({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.detailForm = {
                            shop_id: res.data.shop_id,
                            user_id: res.data.user_id,
                            user_name: res.data.user_name,
                            remark: res.data.remark,
                        };
                    }
                })
                .catch(() => {});
        },
        userSelect(val){
            cmofferApi.userSelect({keyword: val}, "get").then((res) => {
                if (res) {
                    this.userList = res.data;
                }
            });
        }
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        funcName: String,
        shopList: () => Array,
    },
    watch: {
        detailVisible(val) {
            if (val) {
                this.shopOrderRemark();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.detail-remark {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
